/*! md-noticejs - 0.0.18 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("backbone"), require("underscore"));
	else if(typeof define === 'function' && define.amd)
		define("mdnotice", ["jquery", "backbone", "underscore"], factory);
	else if(typeof exports === 'object')
		exports["mdnotice"] = factory(require("jquery"), require("backbone"), require("underscore"));
	else
		root["mdnotice"] = factory(root["jQuery"], root["Backbone"], root["_"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__, __WEBPACK_EXTERNAL_MODULE_5__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _notices = __webpack_require__(2);
	
	var _notices2 = _interopRequireDefault(_notices);
	
	var _view = __webpack_require__(6);
	
	var _view2 = _interopRequireDefault(_view);
	
	var _modal = __webpack_require__(8);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var _sticky = __webpack_require__(10);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var el = void 0;
	var url = void 0;
	var userData = void 0;
	var cors = void 0;
	var notices = void 0;
	var notice = void 0;
	var view = void 0;
	var afterRender = void 0;
	
	var corsOptions = {
	  crossDomain: true,
	  xhrFields: {
	    withCredentials: true
	  }
	};
	
	var getSyncOptions = function getSyncOptions() {
	  return cors === true ? corsOptions : {};
	};
	
	// eslint-disable-next-line arrow-parens
	var notificationSelector = function notificationSelector(id) {
	  return '.notifications[data-noticeid="' + id + '"]';
	};
	
	var loadData = function loadData(callback) {
	  var options = Object.assign({}, getSyncOptions(), {
	    success: function success(response) {
	      if (response.at(0) && response.at(0).attributes.response !== 'error') {
	        callback();
	      }
	    },
	    error: function error(_error, response) {
	      throw new Error('mdnotice.loadData error:', response);
	    }
	  });
	  notices.fetch(options);
	};
	
	var afterRenderCallback = function afterRenderCallback() {
	  if (typeof afterRender === 'function') {
	    afterRender();
	  }
	};
	
	var closeCallbackPopup = void 0;
	var _closeCallback = void 0;
	
	var render = function render() {
	  notice = notices.at(0);
	
	  var id = notice && notice.get('id');
	  if (!id) {
	    afterRenderCallback();
	    return;
	  }
	
	  if ((0, _jquery2.default)(notificationSelector(id)).length > 0) {
	    afterRenderCallback();
	    return;
	  }
	  var popup = parseInt(notice.get('popup'), 10) === 1;
	  var View = popup ? _modal2.default : _view2.default;
	  view = new View({
	    el: el,
	    noticeData: notice.getNoticeData(userData),
	    closeCallback: function closeCallback(data) {
	      var closeFn = popup ? closeCallbackPopup : _closeCallback;
	      return closeFn(data.noticeData, data.delete, data.callback);
	    }
	  });
	  view.render();
	  afterRenderCallback();
	};
	
	var deleteNoticeAction = function deleteNoticeAction(callback) {
	  var id = notice.get('id');
	  var data = JSON.stringify({ id: id });
	
	  var options = Object.assign({}, getSyncOptions(), {
	    data: data,
	    url: url + '/' + id,
	    contentType: 'application/json',
	    success: function success() {
	      (0, _jquery2.default)(notificationSelector(id)).remove();
	      if (callback) {
	        callback();
	      } else {
	        loadData(function () {
	          render();
	        });
	      }
	    },
	    error: function error(_error2, response) {
	      throw new Error('mdnotice.deleteNoticeAction error', _error2, response);
	    }
	  });
	  notice.destroy(options);
	};
	
	closeCallbackPopup = function closeCallbackPopup(noticeData, deleteNotice, callback) {
	  (0, _jquery2.default)('#notice-sticky').remove();
	  view = new _sticky2.default({
	    el: el,
	    noticeData: noticeData,
	    openCallback: function openCallback() {
	      render();
	    }
	  });
	  if (deleteNotice) {
	    return deleteNoticeAction(callback);
	  }
	  view.render();
	  return afterRenderCallback();
	};
	
	_closeCallback = function _closeCallback(noticeData, deleteNotice) {
	  if (deleteNotice) {
	    return deleteNoticeAction();
	  }
	  return (0, _jquery2.default)(notificationSelector(noticeData.id)).remove();
	};
	
	var showNotices = function showNotices() {
	  notices = new _notices2.default([], { url: url });
	  notices.url = url;
	  loadData(function () {
	    render();
	  });
	};
	
	exports.default = {
	  init: function init(options) {
	    el = options.el;
	    // eslint-disable-next-line object-curly-newline
	
	    url = options.url;
	    userData = options.userData;
	    afterRender = options.afterRender;
	    cors = options.cors;
	
	    showNotices();
	  },
	  getNotice: function getNotice() {
	    return notice;
	  },
	  getView: function getView() {
	    return view;
	  },
	  deleteNotice: function deleteNotice() {
	    if (notice) {
	      deleteNoticeAction();
	    }
	  },
	  close: function close() {
	    if (view) {
	      view.close();
	    }
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(3);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _notice = __webpack_require__(4);
	
	var _notice2 = _interopRequireDefault(_notice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Notices = _backbone2.default.Collection.extend({
	  model: _notice2.default
	});
	
	exports.default = Notices;
	module.exports = exports['default'];

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(3);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _underscore = __webpack_require__(5);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var noticeClassMap = {
	  1: 'md__notification--normal',
	  2: 'md__notification--success',
	  3: 'md__notification--warning',
	  4: 'md__notification--error',
	  5: 'md__notification--info'
	};
	
	var iconClassMap = {
	  1: 'ri-information-fill',
	  2: 'ri-checkbox-circle-fill',
	  3: 'ri-information-fill',
	  4: 'ri-error-warning-fill',
	  5: 'ri-information-fill'
	};
	
	var Notice = _backbone2.default.Model.extend({
	  getNoticeData: function getNoticeData(userData) {
	    var id = this.get('id');
	    var lang = userData.lang;
	
	    var type = this.get('type');
	    var title = this.get('title_' + lang);
	    var urlToClose = this.get('urlToClose_' + lang);
	    var button = this.get('button_' + lang);
	
	    var body = this.get('body_' + lang);
	    var closeWithButton = parseInt(this.get('closeWithButton'), 10) === 1;
	
	    if (title && body) {
	      body = body.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	      var titleTemplate = _underscore2.default.template(title);
	      var bodyTemplate = _underscore2.default.template(body);
	
	      return {
	        id: id,
	        lang: lang,
	        title: titleTemplate(userData),
	        body: bodyTemplate(userData),
	        noticeClass: noticeClassMap[type],
	        icon: iconClassMap[type],
	        closeWithButton: closeWithButton,
	        urlToClose: urlToClose,
	        button: button
	      };
	    }
	
	    return false;
	  }
	});
	
	exports.default = Notice;
	module.exports = exports['default'];

/***/ },
/* 5 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _backbone = __webpack_require__(3);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _notice = __webpack_require__(7);
	
	var _notice2 = _interopRequireDefault(_notice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoticesView = _backbone2.default.View.extend({
	  initialize: function initialize(options) {
	    this.options = options || {};
	  },
	
	
	  events: {
	    'click .notifications .close': 'closeAction'
	  },
	
	  render: function render() {
	    if (this.options.noticeData) {
	      this.$el.prepend((0, _notice2.default)(this.options.noticeData));
	    }
	  },
	  close: function close() {
	    this.$el.empty().off();
	  },
	  closeAction: function closeAction() {
	    this.close();
	    if (this.options.closeCallback) {
	      this.options.closeCallback({
	        noticeData: this.options.noticeData,
	        delete: true
	      });
	    }
	  }
	});
	
	exports.default = NoticesView;
	module.exports = exports['default'];

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(data){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	__p+='<div version="'+
	((__t=(("0.0.18")))==null?'':__t)+
	'" data-noticeid="'+
	((__t=(data.id))==null?'':__t)+
	'"\n  class="notifications md__notification__commons '+
	((__t=(data.noticeClass))==null?'':__t)+
	'" style="z-index:100;">\n  <div class="md__notification__header">\n    <div class="flex gap-12 align-center justify-space-between">\n      <div class="flex align-center gap-20">\n        <i id="alert-icon" class="'+
	((__t=(data.icon))==null?'':__t)+
	' h24 w32 f32"></i>\n        <h4 class="md__notification__title">\n          '+
	((__t=(data.title))==null?'':__t)+
	'\n        </h4>\n      </div>\n      <button class="close" type="button"><i class="ri-close-line"></i></button>\n    </div>\n  </div>\n  <div class="md__notification__body">\n    '+
	((__t=(data.body))==null?'':__t)+
	'\n  </div>\n</div>';
	return __p;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _backbone = __webpack_require__(3);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _modal = __webpack_require__(9);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var doNotShowItAgainLabels = {
	  es: 'No mostrar este mensaje de nuevo',
	  en: 'Do not show this message again',
	  it: 'Non mostrare più questo messaggio',
	  pt: 'Não mostrar esta mensagem novamente',
	  fr: 'Ne plus afficher ce message'
	};
	var closeWithButtonLabel = {
	  es: 'Aceptar',
	  en: 'Accept',
	  it: 'Accettare',
	  pt: 'Aceitar',
	  fr: 'Accepter'
	};
	
	var NoticesModalView = _backbone2.default.View.extend({
	  events: {
	    'click #noticeModal .close': 'closeAction',
	    'click #closeWithButton .close': 'closeAction'
	  },
	  initialize: function initialize(options) {
	    this.options = options || {};
	  },
	  render: function render() {
	    var noticeData = this.options.noticeData;
	
	
	    if (noticeData) {
	      noticeData.showItAgainLabel = doNotShowItAgainLabels[noticeData.lang];
	      noticeData.closeWithButtonLabel = noticeData.button ? noticeData.button : closeWithButtonLabel[noticeData.lang];
	
	      this.$el.append((0, _modal2.default)(noticeData));
	      (0, _jquery2.default)('#noticeModal').show();
	    }
	  },
	  close: function close() {
	    (0, _jquery2.default)('#noticeModal').hide();
	    (0, _jquery2.default)('body').removeClass('modal-open');
	    (0, _jquery2.default)('.modal-backdrop').remove();
	    this.$el.empty().off();
	  },
	  closeAction: function closeAction(event) {
	    var _this = this;
	
	    event.preventDefault();
	    var deleteNotice = (0, _jquery2.default)('#showNoticeAgain').is(':checked');
	    this.close();
	    if (event.target.id === 'closeWithButton') {
	      deleteNotice = true;
	    }
	
	    if (this.options.closeCallback) {
	      var callback = null;
	      if (event.target.id === 'closeWithButton' && this.options.noticeData.urlToClose) {
	        callback = function callback() {
	          // eslint-disable-next-line no-undef
	          var bytes = new TextEncoder().encode(window.location);
	          var redirectBase64 = bytes.toBase64();
	
	          // eslint-disable-next-line no-undef
	          window.location = _this.options.noticeData.urlToClose + '/' + redirectBase64;
	        };
	      }
	      this.options.closeCallback({
	        noticeData: this.options.noticeData,
	        delete: deleteNotice,
	        callback: callback
	      });
	    }
	  }
	});
	
	exports.default = NoticesModalView;
	module.exports = exports['default'];

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(data){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	__p+='<div version="'+
	((__t=(("0.0.18")))==null?'':__t)+
	'" id="noticeModal" class="modal md__modal__commons '+
	((__t=(data.noticeClass))==null?'':__t)+
	'" role="dialog"\n    data-backdrop="static" data-keyboard="false">\n    <div class="modal-dialog">\n        <div class="modal-content noticeModal">\n            <div class="md__modal__header">\n                <div class="flex gap-12 align-center justify-space-between">\n                    <div class="flex align-center gap-20">\n                        <i id="alert-icon" class="'+
	((__t=(data.icon))==null?'':__t)+
	' h24 w32 f32"></i>\n                        <h4 class="md__modal__title">\n                            '+
	((__t=(data.title))==null?'':__t)+
	'\n                        </h4>\n                    </div>\n                    <button class="close" type="button"><i class="ri-close-line"></i></button>\n                </div>\n            </div>\n            <div class="md__modal__body" style="overflow: hidden">\n                '+
	((__t=(data.body))==null?'':__t)+
	'\n            </div>\n            <div class="md__modal__footer" style="display: block">\n                <div class="md__checkbox--wrapper">\n                    ';
	 if(!data.closeWithButton){
	__p+='\n                        <input id="showNoticeAgain" type="checkbox" name="showNoticeAgain"\n                            class="md__checkbox--primary js-filter-hidden"><label for="showNoticeAgain">\n                            '+
	((__t=(data.showItAgainLabel))==null?'':__t)+
	'\n                        </label>\n                        ';
	 } else {
	__p+='\n                            <a id="closeWithButton"\n                                class="close pull-left btn boton-principal btn--yellow no-underline content__none"\n                                href="#" title="'+
	((__t=(data.closeWithButtonLabel))==null?'':__t)+
	'">\n                                '+
	((__t=(data.closeWithButtonLabel))==null?'':__t)+
	'\n                            </a>\n                            ';
	 } 
	__p+='\n                </div>\n            </div>\n        </div>\n    </div>\n</div>';
	return __p;
	};


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _backbone = __webpack_require__(3);
	
	var _backbone2 = _interopRequireDefault(_backbone);
	
	var _sticky = __webpack_require__(11);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NoticesStickyView = _backbone2.default.View.extend({
	  events: {
	    'click #notice-sticky-container': 'open'
	  },
	
	  initialize: function initialize(options) {
	    this.options = options || {};
	  },
	  render: function render() {
	    this.$el.append((0, _sticky2.default)(this.options.noticeData));
	    (0, _jquery2.default)('#notice-sticky-container').show();
	  },
	  open: function open() {
	    if (this.options.openCallback) {
	      this.options.openCallback();
	      this.hide();
	    }
	  },
	  hide: function hide() {
	    (0, _jquery2.default)('#notice-sticky-container').hide();
	  },
	  close: function close() {
	    this.hide();
	    this.$el.empty().off();
	  }
	});
	
	exports.default = NoticesStickyView;
	module.exports = exports['default'];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = function(data){
	var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
	__p+='<div version="'+
	((__t=(("0.0.18")))==null?'':__t)+
	'" id="notice-sticky-container" class="md__sticky__commons '+
	((__t=(data.noticeClass))==null?'':__t)+
	'">\n  <div id="notice-sticky" class="md__sticky__content">\n    <div class="flex align-center gap-20">\n      <i id="alert-icon" class="'+
	((__t=(data.icon))==null?'':__t)+
	' h24 w32 f32"></i>\n      <h4 class="md__modal__title">\n        '+
	((__t=(data.title))==null?'':__t)+
	'\n      </h4>\n    </div>\n  </div>\n</div>';
	return __p;
	};


/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** mdnotice.js
 **/